import React from "react";
import FieldDate from "../../../common/component/form/FieldDate";
import FieldText from "../../../common/component/form/FieldText";
import FieldTime from "../../../common//component/form/FieldTime";
import FieldAutoComplete from "../../../common/component/form/FieldAutoComplete";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import ModalBox from "../../../common/component/Modal/Index";
import useAutoComplete from "./../../../common/hooks/useAutoComplete";

function FilterModal() {
  const orderStatus = useAutoComplete();
  const activeStatus = useAutoComplete();
  //   const orderStatus1 = useAutoComplete();
  const lineStatus = useAutoComplete();
  return (
    <ModalBox title="Filter By">
      <div className="_modalBody container-fluid">
        <div className="row ">
          <div className="col-md-6 col-12">
            <FieldText label="Order Number" />
          </div>
          <div className="col-md-6 col-12">
            <div className="width100">
              <FieldAutoComplete
                label="Order Status"
                value={orderStatus.value}
              />
            </div>
          </div>
          <div className="col-md-6 col-12">
            <FieldText label="Buyer" />
          </div>
          <div className="col-md-6 col-12">
            <FieldText label="Supplier" />
          </div>
          <div className="col-12">
            <FieldDate label="Order Creation Date" />
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Filter by No. &amp; Reference</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldText label="Actual Flight / Voyage No." />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Planned Flight / Voyage No." />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Booking Con. Ref. No." />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Commodity Code No." />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Container No." />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="House Bill No." />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Invoice No." />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Master Bill of Lading Number" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Order No." />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Product No." />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Filter by Satus &amp; Flag</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="width100">
                      <FieldAutoComplete
                        label="Active Status"
                        value={activeStatus.value}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="width100">
                      <FieldAutoComplete
                        label="Line Status"
                        value={lineStatus.value}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Attached / Unattached No." />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Commodity Code No." />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Filter by Dates</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldDate label="Confirm Date" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate label="Follow up Date" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate label="Order Date" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate label="Req. Ex works" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate label="Req. in Store" />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Filter by Location</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldText label="Actual Load / Discharge" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Actual Origin / Destination" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Planned Load / Discharge" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Planned Origin / Destination" />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Filter by Organization Staff</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldText label="Actual Carrier" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Actual Notify Party" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Buyer Company Name" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Client Assigned Staff" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Controling Customer" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Pick up Address" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Delivery Address" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Manufacturer" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Planned Carrier" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Actual Carrier" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Planned Notify Party" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Planned Send / Receive Party" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Supply Company Name" />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Filter by Model &amp; Type</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldText label="Container Mode" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Service Level" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Transport Mode" />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Filter by Audit information</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldText label="Created on Web / Internal" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldTime label="Created Time" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldTime label="Last Edit Time" />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Filter by Other</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldText label="Order Line - Quantity invoiced" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldTime label="Order Line - Quantity Received" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldTime label="Product" />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Filter by Workflow Milestone</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <FieldText label="Last Completed Milestone" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Milestone Completed" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldDate label="Milestone Date" />
                  </div>
                  <div className="col-md-6 col-12">
                    <FieldText label="Next Milestone" />
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="col-12">
            <div className="_modalFooter justify-content-between">
              <div className="_outlineButton">
                <button onClick={() => {}}>Clear Filter</button>
              </div>
              <div className="_solidButton">
                <button onClick={() => {}}>Apply</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalBox>
  );
}

export default FilterModal;
